module.exports = __webpack_public_path__ + "static/media/stick-shift-graphic.ffb6e0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/result-page-images/stick-shift-graphic.png
// module id = 354
// module chunks = 0